// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"03753967","377":"4e227321","417":"b726eb66","467":"13292dd4","626":"e5e40771","870":"01ad236a"}[chunkId] + ".js";
};